import store from "@/store";

export const checkLineUser = async (to, from, next) => {
  try {
    const vuex = localStorage.getItem("vuex");
    const defaultSystem = JSON.parse(vuex).defaultSystem;
    const site_name = defaultSystem.site.name;
    const line_id = defaultSystem.userLine.userId;
    const token = localStorage.getItem("token");

    const inviteCode = to.query.invite === undefined ? "" : to.query.invite;
    const platform = to.query.platform === undefined ? "" : to.query.platform;

    store.commit("defaultSystem/SET_USER", { role: "Customer" });
    if (inviteCode) {
      store.commit("friend/SET_INVITE", inviteCode);
    }

    if (platform) {
      store.commit("friend/SET_PLATFORM", to.query.platform);
    }

    localStorage.setItem("lineId", (line_id || ''));
    if (site_name) {
      // Check if the user is trying to access the login-bypass page
      if (
        (from.name === "login-bypass" || to.name === "login-bypass") &&
        !token
      ) {
        return next();
      } else if (to.name === "register-bypass" && !token) {
        return next();
      } else if (token) {
        return next({ name: "main" });
      } else {
        return next({ name: "login-bypass" });
      }
    }
  } catch (error) {
    console.log("error :>> ", error);
  }
};
